import { Col, message, Row } from "antd";
import Axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
//import QrReader from "react-qr-scanner";
import QrReader from "react-qr-reader";
import { ReactComponent as Right } from "../../../static/arrowRight.svg";
import qr from "../../../static/qr.png";
import "./free.scss";

const mapDispatchToProps = (dispatch) => {
  return {};
};

class ConnectedFreeGamers extends Component {
  state = {
    delay: 1000,
    result: "No result",
    gamers: [],
    name: "",
    activeKey: "",
    errorQRs: [],
  };

  typingTimeout = null;

  inputRef = React.createRef();

  handleChange = () => {
    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    this.typingTimeout = setTimeout(() => {
      const value = this.inputRef.current.value
        .replaceAll("É", ":")
        .replaceAll("-", "/")
        .replaceAll("_", "?")
        .replaceAll("ó", "=")
        .replaceAll("z", "#")
        .replaceAll("Z", "@")
        .replaceAll("y", "z")
        .replaceAll("Y", "Z")
        .replaceAll("#", "y")
        .replaceAll("@", "Y")
        .replaceAll("ö", "0");
      this.handleScan(value);
    }, 500);
  };

  componentDidMount() {
    this.inputRef.current.focus();

    this.props.closeKeyboard();
    setInterval(() => {
      this.setState({ errorQRs: [] });
    }, 3000);

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }
  }

  handleScan = async (data) => {
    console.log(data);
    if (data !== null) {
      try {
        const link = data;
        const url = new URL(link);
        const qr = url.searchParams.get("qr");

        let existing = this.state.gamers.filter(
          (gamer) => gamer.qr === qr
        ).length;
        if (existing === 0) {
          await Axios.get("/1.0.0/game/check", { params: { qr: qr } })
            .then((response) => {
              if (response.data.exists === true) {
                if (!this.state.errorQRs.includes(qr)) {
                  message.error(
                    "A megadott játékos már szerepel más csapatnál!",
                    4
                  );
                  this.setState({ errorQRs: [...this.state.errorQRs, qr] });
                }
              } else {
                const gamers = [...this.state.gamers, { qr: qr }];
                this.setState({ gamers: gamers });
                message.success("Sikeres beolvasás!", 4);

                this.handleNext();
              }
            })
            .catch((err) => {
              console.log(err);
              message.error(
                "Hiba az ellenőrzés során kérem szennelje be újra a kódot!",
                5
              );
            });
        } else {
          if (!this.state.errorQRs.includes(qr)) {
            message.error("Játékos már hozzáadva a csapathoz!", 4);
            this.setState({ errorQRs: [...this.state.errorQRs, qr] });
          }
        }
      } catch (err) {
        console.log(err);
        message.error("Hibás QR kód!", 3);
      }
    }
  };
  handleError = (err) => {
    console.error(err);
  };

  handleNext = async () => {
    await Axios.post("/1.0.0/game/team-gamers", {
      name: this.props.teamName,
      email: this.props.email,
      gamers: this.state.gamers,
      institutionId: null,
      categoryId: null,
    });
    this.props.next();
    //this.props.history.push("/");
  };

  render() {
    return (
      <div>
        {/*  <Row>
          <Col span={4}>Játékosok száma: {this.state.gamers.length}</Col>
          <Col
            span={20}
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "1em",
            }}
          >
            <QrReader
              delay={this.state.delay}
              style={{
                height: 320,
                width: 320,
              }}
              onError={this.handleError}
              onScan={this.handleScan}
            />
          </Col>
        </Row>
        <Row style={{ textAlign: "center" }}>
          <div
            style={{
              display: "flex",
              width: "300px",
              margin: "0 auto",
              justifyContent: "center",
            }}
          >
            <Button
              danger
              onClick={this.props.prev}
              style={{ marginRight: "0.5em" }}
            >
              Vissza
            </Button>
            <Button
              type="primary"
              danger
              //htmlType="submit"
              onClick={this.handleNext}
              style={{ marginLeft: "0.5em" }}
            >
              Következő
            </Button>
          </div>
        </Row> */}
        <Row>
          <Col span={6} style={{ padding: "1.5em" }}>
            Játékosok száma: {this.state.gamers.length}
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "1.5em",
            }}
          >
            {/* <QrReader
              delay={this.state.delay}
              style={{
                height: 7,
                width: 421,
              }}
              onError={this.handleError}
              onScan={this.handleScan}
            /> */}

            <img alt="QR" src={qr} className="custom-qr-image" />

            <input
              type="text"
              autocomplete="off"
              style={{ width: 0, opacity: 0 }}
              ref={this.inputRef}
              onChange={this.handleChange}
            ></input>
          </Col>
        </Row>
        <div>
          <button
            className="free-next-button"
            style={{ position: "fixed", bottom: "5%", right: "5%" }}
            onClick={this.handleNext}
            disabled={this.state.gamers.length === 0}
          >
            Következő <Right className="free-arrow-icon" />
          </button>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});
const FreeGamers = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedFreeGamers);
export default FreeGamers;
